// This file is generated by
// services/coaches/cmd/school_picker/generate_typescript.
// Do not edit directly.

// Map of ISO-3166-2 codes to the names of admin level one entities.
export const ADMIN_LEVEL_ONE_CODES_TO_NAMES: Record<string, string> = {
    C: "DHAKA",
};

// Map of the administrative levels used in country.
//
// Level 1 is keyed by ISO-3166-2 code.
// Level 2 is keyed by the names of admin-level-two entities.
// Level 3 contains the names of localities.
export const ADMIN_LEVELS: Record<string, Record<string, string[]>> = {
    C: {
        DHAKA: [
            "ADABOR",
            "BADDA",
            "BANANI",
            "BANGSHAL",
            "BHASAN TEK",
            "BHATARA",
            "BIMAN BANDAR",
            "CANTONMENT",
            "CHAK BAZAR",
            "DAKSHINKHAN",
            "DARUS SALAM",
            "DEMRA",
            "DHAMRAI",
            "DHANMONDI",
            "DOHAR",
            "GENDARIA",
            "GULSHAN",
            "HAJARI BAG",
            "JATRABARI",
            "KADAMTALI",
            "KAFRUL",
            "KALABAGAN",
            "KAMRANGIR CHAR",
            "KERANIGANJ",
            "KHILGAON",
            "KHILKHET",
            "KOTWALI",
            "LALBAGH",
            "MIRPUR",
            "MOHAMMADPUR",
            "MOTIJHEEL",
            "MUGDA PARA",
            "NEW MARKET",
            "NOWABGANJ",
            "PALLABI",
            "PALTAN",
            "RAMNA",
            "RAMPURA",
            "RUPNAGAR",
            "SABUJBAGH",
            "SAVAR",
            "SHAH ALI",
            "SHAHBAG",
            "SHAHJAHANPUR",
            "SHER-E-BANGLA NAGAR",
            "SHYAMPUR",
            "SUTRAPUR",
            "TEJGAON",
            "TEJGAON IND. AREA",
            "TURAG",
            "UTTAR KHAN",
            "UTTARA",
            "UTTARA PASCHIM",
            "WARI",
        ],
        GAZIPUR: [
            "GAZIPUR SADAR",
            "KALIAKAIR",
            "KALIGANJ",
            "KAPASIA",
            "SREEPUR",
        ],
        NARAYANGANJ: [
            "ARAIHAZAR",
            "BANDAR",
            "NARAYANGANJ SADAR",
            "RUPGANJ",
            "SONARGAON",
        ],
        NARSINGDI: [
            "BELABO",
            "MONOHARDI",
            "NARSINGDI SADAR",
            "PALASH",
            "ROYPURA",
            "SHIBPUR",
        ],
    },
};
